import { reject } from 'core-js/fn/promise';
import service from '~api/business';
import * as types from '../types';

export default {
  getQueryTeam({ commit }, payload) {
    return service.apiQueryTeam(payload).then((res) => {
      const data = res.data;
      const loop = (item) => {
        item.forEach((v) => {
          if (v.children.length === 0) {
            delete v.children;
          } else {
            loop(v.children);
          }
        });
      };

      loop(data.children);

      const arr = {
        depth: data.depth,
        label: data.label,
        leaderUserId: data.leaderUserId,
        leaderUserName: data.leaderUserName,
        teamType: data.teamType,
        value: data.value,
        children: data.children,
      };
      commit(types.GET_TEAM_SELECT, [arr]);
    });
  },
  getBusiStageList({ commit }, payload) {
    return service.apiGetBusiStageList(payload).then((res) => {
      if (res.data) {
        commit(types.GET_BUSI_STAGE_LIST, res.data);
      }
    });
  },
  getBusiOpportunityList({ commit }, payload) {
    return service.apiGetBusiOpportunityList(payload).then((res) => {
      if (res.data) {
        commit(types.GET_BUSI_OPPORTUNITY_LIST, res.data);
      }
    });
  },
  saveAddBusiOpprtunity({ commit }, payload) {
    return service.apiSaveAddBusiOpprtunity(payload);
  },
  saveUpdateBusiOpprtunity({ commit }, payload) {
    return service.apiSaveUpdateBusiOpprtunity(payload);
  },
  CustomSelectSearch({ commit }, payload) {
    return service.apiGetCustomSelectData(payload).then((res) => {
      if (res.data) {
        commit(types.GET_CUSTOM_SELECT_DATA, res.data);
      }
    });
  },
  deleteBusiOpportunity({ commit }, payload) {
    return service.apiDeleteBusiOpprtunity(payload);
  },
  getBusiOpprtunityDetail({ commit }, payload) {
    return service.apiGetBusiOpprtunityDetail(payload).then((res) => {
      if (res.data) {
        commit(types.GET_BUSI_OPPORTUNITY_DETAIL, res.data);
      }
    }).catch((error) => {
      commit(types.GET_BUSI_OPPORTUNITY_DETAIL, {});
      throw error
    })
  },
  saveBusiAbolish({ commit }, payload) {
    return service.apiSaveBusiAbolish(payload);
  },
  saveBusiRecover({ commit }, payload) {
    return service.apiSaveBusiRecover(payload);
  },
  getBusiVisitData({ commit }, payload) {
    return service.apiGetBusiVisitData(payload).then((res) => {
      if (res.data) {
        commit(types.GET_BUSI_VISIT_DATA, res.data);
      }
    });
  },
  getBusiSalesData({ commit }, payload) {
    return service.apiGetBusiSalesData(payload).then((res) => {
      if (res.data) {
        commit(types.GET_BUSI_SALES_DATA, res.data);
      }
    });
  },
  getBusiFileData({ commit }, payload) {
    return service.apiGetBusiFileData(payload).then((res) => {
      if (res.data) {
        commit(types.GET_BUSI_FILE_DATA, res.data);
      }
    });
  },
  deleteBusiFile({ commit }, payload) {
    return service.apiDeleteBusiFile(payload);
  },
  saveBusiStageChange({ commit }, payload) {
    return service.apiSaveBusiStageChange(payload);
  },
  uploadFile({ commit }, payload) {
    return service.apiUploadFile(payload.params, payload.config);
  },
  getBusiLineList({ commit }, payload) {
    return service.apiGetBusiStageList(payload).then((res) => {
      if (res.data) {
        commit(types.GET_BUSI_LINE_LIST, res.data);
      }
    });
  },
  exportBusiOpportunity({ commit }, payload) {
    return service.apiBusiOpportunityExport(payload.params, payload.config);
  },
  // 获取业务员列表
  getBusiSalesList({ commit }, payload) {
    return service.apiGetBusiSalesList(payload).then((res) => {
      if (res.data) {
        commit(types.GET_BUSI_SALES_LIST, res.data);
      }
    });
  },
  // 获取新增联系人列表
  getBusiContactsList({ commit }, payload) {
    return service.apiGetBusiContactsList(payload).then((res) => {
      if (res.data) {
        commit(types.GET_BUSI_CONTACT_LIST, res.data);
      }
    });
  },
  // 获取详情联系人列表
  getDetailContactsList({ commit }, payload) {
    return service.apiGetDetailContactsList(payload).then((res) => {
      if (res.data) {
        commit(types.GET_BUSI_DETAIL_CONTACT_LIST, res.data);
      }
    });
  },
};
